import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth-context";
import { publicApi } from "@/lib/api";
import Navbar from "@/components/Navbar";
import Home from "@/pages/Home";
import CharacterDetail from "@/pages/CharacterDetail";
import Flashcards from "@/pages/Flashcards";
import Bookmarks from "@/pages/Bookmarks";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Admin from "@/pages/Admin";
import Profile from "@/pages/Profile";
import About from "@/pages/About";

function AppRouter() {
  const location = useLocation();
  // Synchronously route session_id callback before normal routes.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/character/:id" element={<CharacterDetail />} />
      <Route path="/flashcards" element={<Flashcards />} />
      <Route path="/bookmarks" element={<Bookmarks />} />
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/about" element={<About />} />
      <Route path="*" element={<Home />} />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    // Silent wake-up ping to warm the Render backend on startup.
    // Fire-and-forget: no loading state, no error surfaced to the user.
    publicApi.get("/").catch(() => {});
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Navbar />
          <AppRouter />
          <Toaster position="top-right" richColors closeButton />
          <footer className="border-t border-slate-200 mt-20 py-10 bg-slate-50">
            <div className="container-page text-center">
              <p className="font-serif-display text-xl text-slate-700 mb-1">
                Scripture <span className="text-[#0F766E]">Souls</span>
              </p>
              <p className="text-xs text-slate-500 tracking-wide">
                A scholarly directory of every person across the 66 books.
              </p>
            </div>
          </footer>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
